"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDateTime = exports.parseTime = exports.parseDate = exports.formatDateTime = exports.formatTime = exports.formatDate = void 0;
var number_1 = require("./number");
var errors_1 = require("./errors");
// 仅支持以下标准时间格式的转换
// yyyy = four-digit year
// MM   = two-digit month (01=January, etc.)
// dd   = two-digit day of month (01 through 31)
// HH   = two digits of hour (00 through 23) (am/pm NOT allowed)
// mm   = two digits of minute (00 through 59)
// ss   = two digits of second (00 through 59)
function assertNotValidDatePattern(pattern) {
    if (/[YDhS]/.test(pattern)) {
        throw new errors_1.DateParseError("Pattern string not valid.");
    }
}
function formatDate(d, pattern) {
    if (pattern === void 0) { pattern = "yyyy-MM-dd"; }
    assertNotValidDatePattern(pattern);
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var date = d.getDate();
    return pattern.replace("yyyy", year.toString())
        .replace("MM", number_1.prefixZero(month))
        .replace("dd", number_1.prefixZero(date));
}
exports.formatDate = formatDate;
function formatTime(d, pattern) {
    if (pattern === void 0) { pattern = "HH:mm:ss"; }
    assertNotValidDatePattern(pattern);
    var hour = d.getHours();
    var minute = d.getMinutes();
    var second = d.getSeconds();
    return pattern.replace("HH", number_1.prefixZero(hour))
        .replace("mm", number_1.prefixZero(minute))
        .replace("ss", number_1.prefixZero(second));
}
exports.formatTime = formatTime;
function formatDateTime(d, pattern) {
    if (pattern === void 0) { pattern = "yyyy-MM-dd HH:mm:ss"; }
    return formatDate(d, formatTime(d, pattern));
}
exports.formatDateTime = formatDateTime;
function assertDateParse(dateStr, pattern) {
    if (dateStr.length !== pattern.length) {
        throw new errors_1.DateParseError();
    }
}
function assertBiggerThanZero() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        if (args[i] < 0) {
            throw new errors_1.DateParseError();
        }
    }
}
function assertStringLengthEqual(len) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        if (args[i].length !== len) {
            throw new errors_1.DateParseError("[" + args[i] + "] length should equal to " + len + ".");
        }
    }
}
function assertIsNumber() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        if (isNaN(args[i])) {
            throw new errors_1.DateParseError("[" + args[i] + "] should be a number.");
        }
    }
}
function parseDate(dateStr, pattern) {
    if (pattern === void 0) { pattern = "yyyy-MM-dd"; }
    assertDateParse(dateStr, pattern);
    var yIdx = pattern.indexOf("yyyy");
    var mIdx = pattern.indexOf("MM");
    var dIdx = pattern.indexOf("dd");
    assertBiggerThanZero(yIdx, mIdx, dIdx);
    var yStr = dateStr.substr(yIdx, 4);
    var mStr = dateStr.substr(mIdx, 2);
    var dStr = dateStr.substr(dIdx, 2);
    assertStringLengthEqual(4, yStr);
    assertStringLengthEqual(2, mStr, dStr);
    var year = parseInt(yStr, 10);
    var month = parseInt(mStr, 10);
    var date = parseInt(dStr, 10);
    assertIsNumber(year, month, date);
    return [year, month, date];
}
exports.parseDate = parseDate;
function parseTime(timeStr, pattern) {
    if (pattern === void 0) { pattern = "HH:mm:ss"; }
    assertDateParse(timeStr, pattern);
    var hIdx = pattern.indexOf("HH");
    var mIdx = pattern.indexOf("mm");
    var sIdx = pattern.indexOf("ss");
    assertBiggerThanZero(hIdx, mIdx, sIdx);
    var hStr = timeStr.substr(hIdx, 2);
    var mStr = timeStr.substr(mIdx, 2);
    var sStr = timeStr.substr(sIdx, 2);
    assertStringLengthEqual(2, hStr, mStr, sStr);
    var hour = parseInt(hStr, 10);
    var minute = parseInt(mStr, 10);
    var second = parseInt(sStr, 10);
    assertIsNumber(hour, minute, second);
    return [hour, minute, second];
}
exports.parseTime = parseTime;
function parseDateTime(dateTimeStr, pattern) {
    if (pattern === void 0) { pattern = "yyyy-MM-dd HH:mm:ss"; }
    var _a = __read(pattern.split(" "), 2), datePattern = _a[0], timePattern = _a[1];
    var _b = __read(dateTimeStr.split(" "), 2), dateStr = _b[0], timeStr = _b[1];
    var date = parseDate(dateStr, datePattern);
    var time = parseTime(timeStr, timePattern);
    return new (Date.bind.apply(Date, __spread([void 0], date, time)))();
}
exports.parseDateTime = parseDateTime;
